import { TableElement } from '../types';

export const isCellHeading = (node) => node.type === TableElement.TH;
